import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

import { BannerComponent } from './banner.component';
import { LicenseNamePipeModule } from 'shared/pipes/license-name/license-name-pipe.module';

@NgModule({
    declarations: [BannerComponent],
    imports: [CommonModule, MatIconModule, MatButtonModule, LicenseNamePipeModule],
    exports: [BannerComponent],
})
export class BannerModule {}
